import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

function ItemProductoPurchaseAccept({ product, pivot }) {
    const price = pivot?.price || product.price;
    const imageSrc = product.first_imagen || product.first_image;

    return (
        <Link className="no-underline group h-full block" to={`/producto/${product.slug}`}>
            <div className="bg-white border border-gray-100 rounded-xl shadow-sm relative overflow-hidden transform transition-all duration-300 hover:shadow-md hover:border-ecoprimary1/30 h-full flex flex-col">
                <div className="relative aspect-square overflow-hidden bg-gray-50 flex-shrink-0">
                    {imageSrc ? (
                        <img
                            src={imageSrc}
                            alt={product.name}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-400">
                            <span className="text-xs">Sin imagen</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-col flex-grow justify-between p-3 sm:p-4">
                    <p className="mb-1 text-gray-700 text-sm font-medium line-clamp-2 leading-snug">{product.name}</p>
                    {product.store_name && (
                        <p className="text-xs text-gray-500 mb-2">Tienda: {product.store_name}</p>
                    )}

                    <div className="mt-auto flex justify-between items-end">
                        <p className="font-bold mb-0 text-ecoprimary1 text-lg">
                            Bs {price}
                        </p>
                        {product.quantity && (
                            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                Cant: {product.quantity}
                            </span>
                        )}
                    </div>
                </div>
                <div className="px-3 pb-3 sm:px-4 sm:pb-4 mt-auto">
                    <button className="bg-blue-50 text-blue-700 border border-blue-100 font-medium px-4 py-2 rounded-lg text-sm w-full transition-colors group-hover:bg-blue-100 group-hover:border-blue-200 group-active:bg-blue-200">
                        Ver producto
                    </button>
                </div>
            </div>
        </Link>
    );
}

// Conectamos el componente a Redux
export default connect(null, { })(ItemProductoPurchaseAccept);
